export default __webpack_public_path__ + "static/media/cbp_dark.bf344b50.svg";